export const SkillsData = [
    {
        Skill: "Frontend",
        List: [
            {
                name: "ReactJS",
                icon: <i class="devicon-react-original-wordmark colored"></i>
            },

            {
                name: "Javascript",
                icon: <i class="devicon-javascript-plain colored"></i>
            },

            {
                name: "CSS",
                icon: <i class="devicon-css3-plain-wordmark colored"></i>
            },

            {
                name: "HTML",
                icon: <i class="devicon-html5-plain-wordmark colored"></i>
            },

            {
                name: "Bootstrap",
                icon: <i class="devicon-bootstrap-plain-wordmark colored"></i>

            }
        ]

    }, {
        Skill: "Additionals",
        List: [
            {
                name: "Git",
                icon: <i class="devicon-git-plain"></i>
            },

            {
                name: "Github",
                icon: <i class="devicon-github-original colored"></i>
            },

            {
                name: "npm",
                icon: <i class="devicon-npm-original-wordmark colored"></i>
            }

        ]

    }
]

export default SkillsData